import { BiSupport } from 'react-icons/bi';
import {
  PiBell,
  PiCalendarDots,
  PiCode,
  PiEnvelope,
  PiHouseLine,
  PiMoneyWavy,
  PiUser,
  PiUsersThree,
  PiWrench,
} from 'react-icons/pi';
import { environment } from 'services/environment/Environment';
import { INavbarItem } from 'types/navbar/navbar.interface';

interface ISettingsNavbarOptions {
  isDemo?: boolean;
  clientUserAvailable?: boolean;
}

export const settingsNavbarItems = (
  options?: ISettingsNavbarOptions
): INavbarItem[] => [
  {
    path: 'settings',
    name: 'user',
    icon: PiUser,
  },
  {
    path: 'settings/application',
    name: 'application',
    icon: PiHouseLine,
  },
  {
    path: 'settings/email',
    name: 'email',
    icon: PiEnvelope,
  },
  {
    path: 'settings/notifications',
    name: 'notifications',
    icon: PiBell,
  },

  {
    path: 'settings/license',
    name: 'license',
    icon: PiHouseLine,
  },

  {
    path: 'settings/sales-channel',
    name: 'sales-channel',
    icon: PiMoneyWavy,
    permissionNames: ['SalesChannelPermissionsLIST**'],
  },
  {
    path: 'settings/provider',
    name: 'provider',
    icon: PiMoneyWavy,
    permissionNames: ['ProvidersPermissionsLIST**'],
  },
  {
    path: 'settings/settlement-periods',
    name: 'settlement-periods',
    icon: PiCalendarDots,
    permissionNames: ['SettlementPeriodPermissionsLIST**'],
  },
  {
    path: 'settings/users',
    name: 'users',
    icon: PiUsersThree,
  },
  {
    path: 'settings/serviceCode',
    name: 'serviceCode',
    icon: BiSupport,
  },
  ...(options?.isDemo
    ? [
        {
          path: 'settings/demo',
          name: 'demo',
          icon: PiWrench,
        },
      ]
    : []),
  ...(environment().node.nodeEnv === 'development'
    ? [
        {
          path: 'dev-tools/error-codes',
          name: 'dev-tools',
          icon: PiCode,
        },
      ]
    : []),
];
